import {Component, OnInit} from '@angular/core';
import {JhiEventManager} from 'ng-jhipster';
import {Principal} from '../auth/principal.service';
import {AuthServerProvider} from '../auth/auth-jwt.service';
import {Router} from '@angular/router';
import {catchError, debounceTime, distinctUntilChanged, map, switchMap, tap} from 'rxjs/operators';
import {ListItemModel} from '../../component/select-custom/list.item.model';
import {of} from 'rxjs/observable/of';
import {Observable} from 'rxjs/Observable';
import {AccountService} from '../auth/account.service';
import {NotificheService} from "../../notifiche/notifiche.service";
import {MessageService} from "../../MessageService";
import { Subscription } from 'rxjs/Subscription';

let comitees: any[] = [];

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})

export class NavbarComponent implements OnInit {

  account: any;
  selected: any;
  comitees: any[];
  notifiche: any[];

  subscription: Subscription;

  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      map(term => term === '' ? []
        : comitees.filter(v => v.code.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    );

  constructor(
    private authServerProvider: AuthServerProvider,
    private eventManager: JhiEventManager,
    private principal: Principal,
    private accountService: AccountService,
    private notificheService: NotificheService,
    private messageService: MessageService,
    private router: Router
  ) {
  }

  ngOnInit() {
    this.getAccount();
    this.registerAuthenticationSuccess();
    this.accountService.searchAccess().subscribe((data) => {
      comitees = data;
      this.comitees = data;
    });
    this.reloadNotification();
  }

  private getAccount() {
    this.principal.identity().then((account) => {
      this.account = account;
    });
  }

  formatter = (x: {code: string}) => x.code;

  selectedItem($event) {
    if ($event) {
     this.loginAs($event.item.id);
    }
  }

  registerAuthenticationSuccess() {
    this.eventManager.subscribe('authenticationSuccess', (message) => {
      this.principal.identity(true).then((account) => {
        this.account = account;
      });
    });
    this.subscription = this.messageService.getMessage().subscribe(eventName => {
      if(eventName.text == "notificationChange"){
        this.reloadNotification()
      }
    });
  }

  private reloadNotification() {
    this.notificheService.getNotification().subscribe((res) => {
      this.notifiche = res;
      this.notifiche.forEach((notify) => {
        if ((notify.fkType == 0 && notify.read == true) || (notify.vote == true)) {
          this.notifiche.pop();
        }
      })
    });
  }

  loginAs(id?: number) {
    console.log('loginAs ' + id );
    const currentUrl = this.router.url;

    this.authServerProvider.loginAs(id).subscribe(res => {

      if (currentUrl.includes('walletadmin')) {
        console.log(1)
        this.router.navigate(['/wallet']);
      } else if (currentUrl.includes('wallet') && id === 1) {
        console.log(2)
        this.router.navigate(['/walletadmin']);
      } else if (currentUrl.includes('wallet') && id !== 1) {
        console.log(3)
        this.router.navigate(['/wallet']);
      }


      this.eventManager.broadcast({
        name: 'authenticationSuccess',
        content: 'Sending Authentication Success'
      });


      if (currentUrl.includes('walletadmin')) {
        this.router.navigate(['/wallet']);
        console.log(1)
        setTimeout(()=>{location.reload()}, 1500) ;

      } else if (currentUrl.includes('wallet') && id === 1) {
        this.router.navigate(['/walletadmin']);
        console.log(2)
        setTimeout(()=>{location.reload()}, 1500) ;

      } else if (currentUrl.includes('wallet') && id !== 1) {
        this.router.navigate(['/wallet']);
        console.log(3)
        setTimeout(()=>{location.reload()}, 1500) ;

      } else{
        location.reload();
      }



    });
  }

  loginExit() {
    // console.log(this.account);
    console.log('loginExit ' );
    console.log(this.account );

    const currentUrl = this.router.url;

    if(this.account.structureType == 3 && this.comitees.length>0){

      this.authServerProvider.loginAs(this.comitees[0].id).subscribe(res => {

        this.eventManager.broadcast({
          name: 'authenticationSuccess',
          content: 'Sending Authentication Success'
        });

        location.reload();


      });
    }

  }


  logout() {
    this.authServerProvider.logout().subscribe(res => {});
    this.principal.authenticate(null);
    this.router.navigate(['/login']);
  }

  openNotifica(id) {
    this.router.navigate(['/elenco-notifiche', id]);
  }

  listaNotifiche() {
    this.router.navigate(['/elenco-notifiche']);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/navbar/navbar.component.ts